import Input from '@material-ui/core/Input';
import SearchIcon from '@material-ui/icons/Search';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import inputGuard from './lib/inputGuard';

const GuardedInput = inputGuard({
  component: Input,
  valueProp: 'value',
  changeHandlerProps: ['onChange'],
});

const TableSearch = ({ search, currentFilter, onChange, placeholder }) => {
  const { t } = useTranslation('general');

  return (
    <GuardedInput
      fullWidth
      placeholder={placeholder || t('Search') || 'Search'}
      defaultValue={search}
      value={search}
      onChange={event => {
        if (onChange) {
          onChange({ search: event.target.value || '' });
          return;
        }
        const output = currentFilter || {};
      }}
      startAdornment={<SearchIcon />}
    />
  );
};

TableSearch.propTypes = {
  search: PropTypes.string,
  currentFilter: PropTypes.object, // Keeping it as `object` to reflect that it can be any shape
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
};

TableSearch.defaultProps = {
  search: '',
  currentFilter: undefined,
  onChange: undefined,
  placeholder: undefined,
};

export default TableSearch;
